export default "__VITE_ASSET__C85CtgoN__"